/**
 * Procedure Categories and Procedures for MD in Palliative Medicine students
 * Extracted with strict evidence from official NMC PDF (Page 37-38 & 52-53: "Procedural Skills")
 */
export const PALLIATIVE_MEDICINE_PROCEDURES = {
  "Pain Management & Vascular Access Procedures": [
    "Subcutaneous & Intravenous Line Insertion & Medication Administration",
    "Syringe Driver Setup, Dose Calculation & Continuous Infusion Administration",
    "Patient Controlled Analgesia (PCA) Pump & Ambulatory Drug Device Operation",
    "Epidural & Intrathecal Catheter Management",
    "Administration of Palliative Sedation",
  ],
  "Palliative Interventional & Respiratory Procedures": [
    "Diagnostic & Therapeutic Paracentesis (Abdominal Tap)",
    "Pleurocentesis & Intercostal Drain Management",
    "Pericardiocentesis",
    "Oxygen Therapy, Nebulization & Non-Invasive Respiratory Support Device Operation",
    "Nasogastric & Nasojejunal Tube Insertion",
    "Indwelling & Suprapubic Urinary Catheter Insertion",
  ],
  "Wound, Stoma & Lymphedema Care Procedures": [
    "Malignant Wound & Pressure Ulcer Dressing & Debridement",
    "Tracheostomy Tube Care, Suctioning & Dressing",
    "Gastrostomy & Colostomy Care, High-Up Enemas & Colostomy Irrigation",
    "Complete Decongestive Therapy for Lymphedema (Bandaging, Massage & Exercise)",
  ],
};

export const PALLIATIVE_MEDICINE_CATEGORIES = Object.keys(PALLIATIVE_MEDICINE_PROCEDURES);

export const isMDInPalliativeMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("palliative medicine") || d.includes("palliative care") || d.includes("palliative");
};
